export default "__VITE_ASSET__RLm_ntI5__"